import phaseMixin from './phaseMixin'

export default {
	methods: {
		getGameTimeSince (gamePhaseStart, regularDuration, previousMinutes) {
			const start = new Date(gamePhaseStart)
			const now = new Date()

			const durationMS = now.getTime() - start.getTime()
			const diffAsMinutes = durationMS / 60000
			const diffSeconds = (durationMS / 1000) % 60

			var regularMinutes = Math.floor(Math.min(diffAsMinutes, regularDuration))
			var isOvertime = diffAsMinutes > regularDuration
			var overtimeMinutes = Math.floor(diffAsMinutes - regularMinutes)
			var seconds = diffSeconds

			return {
				minutes: regularMinutes + previousMinutes,
				isOvertime,
				overtimeMinutes,
				seconds
			}
		},
		getGameTimeForPhase (phase) {
			const regularDuration = phaseMixin.methods.getRegularDurationForPhase(phase.key)
			const previousMinutes = phaseMixin.methods.getInitialMinutesForPhase(phase.key)
			return this.getGameTimeSince(phase.start, regularDuration, previousMinutes)
		}
	}
}
